export * from './group'
export * from './group-heading'
export * from './option'

// components to remove
export const Control = () => null
export const DropdownIndicator = null
export const IndicatorSeparator = null
export const ValueContainer = () => null
